import { render, staticRenderFns } from "./AlarmGroups.vue?vue&type=template&id=1905d3e3"
import script from "./AlarmGroups.vue?vue&type=script&lang=js"
export * from "./AlarmGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports